export default __webpack_public_path__ + "1e11fd16221117d8ded6f6ed7f571376.svg";